module.exports = __webpack_public_path__ + "img/l-steg.86ebdd99.png";